<div class="forecast-list-panel">
  <div class="list-container">
    <div class="list-header">
      <div class="header-left">
        <app-back-button
          [title]="'Yield Forecast List' | translate"
          [parentRoute]="'/crop-yield-forecasts'"></app-back-button>
      </div>
      <div class="header-right"></div>
    </div>

    <div class="table-wrapper">
      <div
        class="loading-indicator"
        *ngIf="isLoading">
        <p>{{ "Loading..." | translate }}</p>
      </div>

      <p-table
        [value]="forecasts"
        [scrollable]="true"
        scrollHeight="flex"
        styleClass="p-datatable-gridlines custom-table"
        [tableStyle]="{ 'min-width': '60rem' }">
        <ng-template pTemplate="header">
          <tr>
            <th>{{ "Date" | translate }}</th>
            <th>{{ "Region / District" | translate }}</th>
            <th>{{ "Field" | translate }}</th>
            <th>{{ "Culture" | translate }}</th>
            <th>{{ "Area (ha)" | translate }}</th>
            <th>{{ "Yield (ц/га)" | translate }}</th>
            <th>{{ "Forecast (ton)" | translate }}</th>
          </tr>
        </ng-template>
        <ng-template
          pTemplate="body"
          let-item>
          <tr
            class="forecast-row"
            (click)="openForecastModal(item)">
            <td>{{ item.forecastDate | date: "dd.MM.yyyy HH:mm" }}</td>
            <td>
              <div class="location-cell">
                <span class="region-name">
                  {{ (getRegionDisplayInfo(item.regionId).region | serverTranslate: "names") || "-" }}
                </span>
                <span class="district-name">
                  {{ (getRegionDisplayInfo(item.regionId).district | serverTranslate: "names") || "-" }}
                </span>
              </div>
            </td>
            <td>
              <span
                class="field-link"
                (click)="onFieldLinkClick($event, item.fieldId)"
                [title]="getFieldName(item.fieldId)">
                {{ getFieldName(item.fieldId) }}
              </span>
            </td>
            <td>
              {{ (getCropById(item.cropId) | serverTranslate: "names") || "-" }}
            </td>
            <td>{{ item.area | number: "1.2-2" }}</td>
            <td>{{ item.yield | number: "1.2-2" }}</td>
            <td>{{ item.forecastAbsolute | number: "1.2-2" }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td
              colspan="7"
              class="text-center p-4">
              {{ "No data found" | translate }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <div
      class="mt-auto"
      *ngIf="totalCount > 0">
      <app-custom-paginator
        [first]="first"
        [pageSize]="pageSize"
        [totalRecords]="totalCount"
        (pageChange)="onPageChange($event)"
        (pageSizeChange)="onPageSizeChange($event)"></app-custom-paginator>
    </div>
  </div>

  <div class="data-filters">
    <div class="filter-header">
      <h3>{{ "Filters" | translate }}</h3>
      <span class="icon-filter-list"></span>
    </div>
    <form
      class="filter-form"
      (ngSubmit)="applyFilters()">
      <div class="form-group">
        <app-region-tree-select
          [regions]="regions"
          [selectedRegionId]="filters.regionId"
          (regionSelected)="onRegionSelected($event)"></app-region-tree-select>
      </div>

      <div class="form-group">
        <app-generic-selector
          [config]="cropSelectorConfig"
          [(ngModel)]="filters.cropId"
          name="cropId"
          [label]="'Culture' | translate"
          [placeholder]="'Select culture' | translate"></app-generic-selector>
      </div>

      <div class="form-group">
        <app-generic-selector
          [config]="fieldSelectorConfig"
          [(ngModel)]="filters.fieldId"
          name="fieldId"
          [label]="'Field' | translate"
          [placeholder]="'Select field' | translate"></app-generic-selector>
      </div>

      <div class="form-group">
        <label>{{ "Forecast Date" | translate }}</label>
        <div class="date-range-group">
          <app-date-picker
            [(ngModel)]="filters.startDate"
            name="startDate"
            [placeholder]="'Start' | translate"
            [showIcon]="true"
            [showClear]="true"></app-date-picker>
          <span class="date-separator">-</span>
          <app-date-picker
            [(ngModel)]="filters.endDate"
            name="endDate"
            [placeholder]="'End' | translate"
            [showIcon]="true"
            [showClear]="true"></app-date-picker>
        </div>
      </div>

      <div class="form-actions">
        <button
          type="button"
          class="btn btn-secondary btn-block"
          (click)="resetFilters()">
          {{ "Reset filter" | translate }}
        </button>
        <button
          type="submit"
          class="btn btn-primary btn-block">
          {{ "Apply" | translate }}
        </button>
      </div>
    </form>
  </div>
</div>

<app-crop-yield-forecast-detail-dialog
  [visible]="forecastModalVisible"
  [forecast]="selectedForecast"
  [fieldName]="selectedFieldName"
  [crop]="selectedCrop"
  [region]="selectedRegion"
  [district]="selectedDistrict"
  (closed)="closeForecastModal()"
></app-crop-yield-forecast-detail-dialog>
